import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, Sparkles, ShoppingBag, Search, Layers } from "lucide-react";
import { useStore } from "@/lib/store";

const ITEMS = [
  { to: "/", label: "Home", icon: Home, testid: "mobile-nav-home" },
  { to: "/shop", label: "Shop", icon: Layers, testid: "mobile-nav-shop" },
  { key: "search", label: "Search", icon: Search, testid: "mobile-nav-search" },
  { to: "/quiz", label: "Quiz", icon: Sparkles, testid: "mobile-nav-quiz" },
  { key: "cart", label: "Cart", icon: ShoppingBag, testid: "mobile-nav-cart" },
];

export function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setCartOpen, setSearchOpen, cart } = useStore();
  const itemCount = (cart?.lines || []).reduce((n, l) => n + (l.quantity || 0), 0);

  const isActive = (to) => (to === "/" ? location.pathname === "/" : location.pathname.startsWith(to));

  const handle = (it) => {
    if (it.key === "cart") { setCartOpen(true); return; }
    if (it.key === "search") { setSearchOpen(true); return; }
    navigate(it.to);
  };

  return (
    <nav
      data-testid="mobile-bottom-nav"
      aria-label="Mobile navigation"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 sd-frosted border-t border-black/10"
      style={{ backgroundColor: "hsl(var(--sd-ivory) / 0.92)", paddingBottom: "max(env(safe-area-inset-bottom), 0px)" }}
    >
      <ul className="grid grid-cols-5 h-[64px]">
        {ITEMS.map((it) => {
          const active = it.to ? isActive(it.to) : false;
          const Icon = it.icon;
          return (
            <li key={it.testid} className="flex">
              <button
                data-testid={it.testid}
                onClick={() => handle(it)}
                aria-label={it.label}
                className={`flex-1 flex flex-col items-center justify-center gap-0.5 relative transition-colors ${
                  active ? "text-[#C5A059]" : "text-[#1A1918]/70 hover:text-[#1A1918]"
                }`}
              >
                <div className="relative">
                  <Icon className="h-[20px] w-[20px]" strokeWidth={1.6} />
                  {it.key === "cart" && itemCount > 0 && (
                    <span className="absolute -top-1.5 -right-2 bg-[#C5A059] text-[#1A1918] rounded-full text-[9px] min-w-[14px] h-[14px] px-1 flex items-center justify-center font-medium">
                      {itemCount}
                    </span>
                  )}
                </div>
                <span className="text-[10px] tracking-[0.08em] uppercase">{it.label}</span>
                {active && <span className="absolute top-0 h-[2px] w-8 bg-[#C5A059] rounded-full" />}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default MobileBottomNav;
